import {
	buildMobileLabels,
	transformLabels
} from 'src/apps/mobile-common/helpers/MobileLabelsHelper';
import { IMobileSdkTestDetails } from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { getFirstStringValue, returnNonNull } from 'src/common/helpers/ArraysHelper';
import { MOBILE_SDK_TYPES_MAP } from 'src/common/helpers/MobileQueriesHelper';

import { MobileSdkTestDetailsQuery } from '../MobileSdkTestDetails.generated';

export const transformMobileSdkTestDetailsResults = (
	result: MobileSdkTestDetailsQuery
): IMobileSdkTestDetails | null => {
	const testData = result.msdk_report_runs?.filter(returnNonNull)?.[0];

	if (!testData) {
		return null;
	}

	const allLabels = transformLabels(testData.custom_fields, buildMobileLabels(testData));

	return {
		testName: getFirstStringValue(testData.test_name),
		lastModified: testData.run_time,
		labels: allLabels,
		appName: getFirstStringValue(testData.app),
		appVersion: getFirstStringValue(testData.app_version),
		sdkType: MOBILE_SDK_TYPES_MAP[testData.sdk_type] ?? '',
		productVersion: getFirstStringValue(testData.product_version)
	};
};
